module.exports = __webpack_public_path__ + "cf1ed6c3b29dd3a3beb40720f0657053.png";